export const styles = () => ({
  arrowIcon: { alignSelf: 'center', marginLeft: '4px !important' }
});
